import { getFirestore, collection, doc, getDoc, getDocs, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import Vue from "vue";
const db = getFirestore();
import Axios from "axios";
import VueAxios from "vue-axios";
import axios from "axios";
import moment from 'moment';

Vue.use(VueAxios, Axios);

const resultsCollection = collection(db, 'globalResults');

const getUserData = async (userId) => {
    try {
        if (userId) {
            const user = await getDoc(doc(db, 'users', userId));
            if (user.exists) {
                return { id: user.id, ...user.data() };
            }
        }
        return undefined;
    } catch (error) {
        console.error(error);
    }
}

const downloadJSONFileFromUrl = async (url) => {
    try {
        if (url && url !== "") {
            const response = await axios.get(url);
            return response.data;
        }
    } catch (error) {
        console.error(error);
    }
}

const getHistoricalAndSecBySec = async (resultData) => {
    let secBySec = null;
    if (resultData.secBySecJson) {
        secBySec = await downloadJSONFileFromUrl(resultData.secBySecJson);
    } else {

    }
    const historical = await downloadJSONFileFromUrl(resultData.historicalUrl);

    return { historical, secBySec };
}

const getClassResult = async (userId, resultId, userData) => {
    console.log('getClassResult', userId, resultId, userData);
    try {
        const classResult = await getDoc(doc(db, 'users', userId, 'proTrainingSaves', resultId));
        // console.log('classResult', classResult);
        if (classResult.exists()) {
            const resultData = classResult.data();
            let session = null;
            try {
                const session = await getDoc(doc(db, 'proTrainersList', resultData.trainId));
                session = { ...session.data(), id: session.id };
            } catch (error) {
                console.log('error', error);
            }
            console.log('session', session);
            const historical = await downloadJSONFileFromUrl(resultData.historicalUrl);
            const secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);
            return {
                ...resultData,
                id: classResult.id,
                createdAt: resultData.createdAt.toDate(),
                user: userData,
                session,
                historical: historical,
                secBySec: secBySec
            };
        }
    } catch (error) {
        console.error(error);
    }
}

const getLiveResult = async (userId, resultId, userData) => {
    try {
        const liveResult = await getDoc(doc(db, 'users', userId, 'livesSaves', resultId));
        if (liveResult.exists()) {
            const resultData = liveResult.data();
            const secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);
            const session = await getDoc(doc(db, 'livesList', resultData.sessionId));
            return {
                ...resultData,
                id: liveResult.id,
                createdAt: resultData.createdAt.toDate(),
                user: userData,
                secBySec: secBySec,
                session: { ...session.data(), id: session.id }
            };
        }
    } catch (error) {
        console.error(error);
    }
}

const fetchExerciseData = async (exercisesSaves) => {
    if (!exercisesSaves || !exercisesSaves.length) {
        console.log('No exercisesSaves found in resultData');
        return exercisesSaves;
    }

    console.log('Found exercisesSaves:', exercisesSaves.length);
    const exercisesPromises = exercisesSaves.map(async (exercise) => {
        // Ya hidratado (p. ej. viene del endpoint) → no volver a consultar
        if (exercise.exercise) return exercise;

        // La app guarda el id como exerciseId; docs viejos usan idExercise
        const exerciseId = exercise.idExercise || exercise.exerciseId;
        if (exerciseId) {
            console.log('Looking for exercise with ID:', exerciseId);
            // Try to get exercise from excercises collection first
            let exDoc = await getDoc(doc(db, 'excercises', exerciseId));
            console.log('Checked excercises collection:', exDoc.exists());
            if (!exDoc.exists()) {
                // If not found, try excercisesNew collection
                exDoc = await getDoc(doc(db, 'excercisesNew', exerciseId));
                console.log('Checked excercisesNew collection:', exDoc.exists());
            }
            if (exDoc.exists()) {
                console.log('Found exercise data:', exDoc.data());
                return {
                    ...exercise,
                    exercise: { ...exDoc.data(), id: exDoc.id }
                };
            } else {
                console.log('Exercise not found in either collection');
            }
        } else {
            console.log('No idExercise found in exercise:', exercise);
        }
        return exercise;
    });

    return await Promise.all(exercisesPromises);
};

const getPresetResult = async (userId, resultId, userData) => {
    try {
        const presetResult = await getDoc(doc(db, 'users', userId, 'proWorkOutSaves', resultId));
        if (presetResult.exists()) {
            const resultData = presetResult.data();
            const secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);
            const session = await getDoc(doc(db, 'preSetsList', resultData.sessionId));

            // Fetch exercise data for each exercise in exercisesSaves
            resultData.exercisesSaves = await fetchExerciseData(resultData.exercisesSaves);

            return {
                ...resultData,
                id: presetResult.id,
                createdAt: resultData.createdAt.toDate(),
                user: userData,
                secBySec: secBySec,
                session: { ...session.data(), id: session.id }
            };
        }
    } catch (error) {
        console.error('Error in getPresetResult:', error);
    }
}

const getFreestyleResult = async (userId, resultId, userData) => {
    try {
        const freestyleResult = await getDoc(doc(db, 'users', userId, 'freeStyleSaves', resultId));
        if (freestyleResult.exists()) {
            const resultData = freestyleResult.data();
            const historical = await downloadJSONFileFromUrl(resultData.historicalUrl);
            const secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);
            return {
                ...resultData,
                id: freestyleResult.id,
                createdAt: resultData.createdAt.toDate(),
                user: userData,
                historical: historical,
                secBySec: secBySec
            };
        }
    } catch (error) {
        console.error(error);
    }
}

const getByoResult = async (userId, resultId, userData) => {
    try {
        const byoResult = await getDoc(doc(db, 'users', userId, 'newBuildYourOwnSaves', resultId));
        if (byoResult.exists()) {
            const resultData = byoResult.data();
            const session = await getDoc(doc(db, 'users', userId, 'byoSessions', resultData.sessionId));
            const secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);

            // Fetch exercise data for each exercise in exercisesSaves
            resultData.exercisesSaves = await fetchExerciseData(resultData.exercisesSaves);

            return {
                ...resultData,
                id: byoResult.id,
                createdAt: resultData.createdAt.toDate(),
                user: userData,
                session: { ...session.data(), id: session.id },
                secBySec: secBySec
            };
        }
    } catch (error) {
        console.error('Error in getByoResult:', error);
    }
}

export default {
    state: {},
    mutations: {},
    actions: {
        /**
         * Trae la lista de resultados de un usuario desde la Cloud Function
         * getResultsByRangeTest. Sin startDate/endDate el backend procesa todo
         * el historial (analytics/charts completos) pero regresa solo los 50
         * resultados más recientes en orderedResults.
         * @returns {{ orderedResults: Array, analyticsData: Object, chartsData: Object }}
         */
        async getUserResultsByRange({ commit }, { userId, startDate, endDate, tabIndex }) {
            const res = await Vue.axios.post(
                'https://us-central1-maxfit-app.cloudfunctions.net/getResultsByRangeTest',
                { userId, startDate, endDate, tabIndex },
                { headers: null }
            );
            return res.data;
        },
        async getResultData({ commit }, data) {
            try {
                const userId = data.user.id;
                const result = await getDoc(doc(resultsCollection, data.resultId));
                // Nota: en Firebase v9 modular exists es método, no propiedad.
                if (result.exists()) {

                    let resultData = {
                        ...result.data(), id: result.id, createdAt: result.data().createdAt.toDate(),
                        user: data.user
                    };

                    // Igual que la app: historical (reps) y secBySec viven en JSONs
                    // externos referenciados desde el doc. Sin esto la gráfica y
                    // los tabs HRZ/VBT quedan vacíos para freestyle/live.
                    if (!resultData.historical && resultData.historicalUrl) {
                        resultData.historical = await downloadJSONFileFromUrl(resultData.historicalUrl);
                    }
                    if (!resultData.secBySec && resultData.detailSecondBySecondUrl) {
                        resultData.secBySec = await downloadJSONFileFromUrl(resultData.detailSecondBySecondUrl);
                    }

                    // preSet/byo: los saves solo traen el id del ejercicio; se
                    // hidrata el doc para poder mostrar nombre en la lista.
                    if (Array.isArray(resultData.exercisesSaves) && resultData.exercisesSaves.length > 0) {
                        resultData.exercisesSaves = await fetchExerciseData(resultData.exercisesSaves);
                    }

                    switch (data.type) {
                        case 'coachedClass':
                            const session = await getDoc(doc(db, 'proTrainersList', resultData.trainId));
                            resultData.session = { ...session.data(), id: session.id };
                            break;
                    }
                    switch (data.type) {
                        case 'live':
                            const session = await getDoc(doc(db, 'livesList', resultData.sessionId));
                            resultData.session = { ...session.data(), id: session.id };
                            break;
                    }
                    switch (data.type) {
                        case 'preSet':
                            const session = await getDoc(doc(db, 'preSetsList', resultData.sessionId));
                            resultData.session = { ...session.data(), id: session.id };
                            break;
                    }
                    switch (data.type) {
                        case 'byo':
                            // BYO compartidos guardan la sesión en sharedByoList
                            const sessionRef = resultData.isShared
                                ? doc(db, 'sharedByoList', resultData.sessionId)
                                : doc(db, 'users', userId, 'byoSessions', resultData.sessionId);
                            const session = await getDoc(sessionRef);
                            resultData.session = { ...session.data(), id: session.id };
                            break;
                    }

                    return resultData;
                }

                switch (data.type) {
                    case 'coachedClass':
                        console.log('classResult', classResult);
                        const classResult = await getClassResult(userId, data.resultId, data.user);

                        return classResult;
                    case 'live':
                        const liveResult = await getLiveResult(userId, data.resultId, data.user);
                        return liveResult;
                    case 'preSet':
                        const presetResult = await getPresetResult(userId, data.resultId, data.user);
                        return presetResult;
                    case 'Freestyle':
                        const freestyleResult = await getFreestyleResult(userId, data.resultId, data.user);
                        return freestyleResult;
                    case 'byo':
                        const byoResult = await getByoResult(userId, data.resultId, data.user);
                        return byoResult;
                    default:
                        return undefined
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    getters: {},
};
